import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { LeadAnuncioResumoDto, QualificacaoAnuncio, RespostaAnuncios } from '@crm/shared'
import { api } from './cliente'
import { chavesChat } from './hooks-chat'

export const chavesAnuncios = {
  raiz: ['anuncios'] as const,
  lista: (filtro: FiltroAnunciosTela) => ['anuncios', 'lista', filtro] as const,
}

export interface FiltroAnunciosTela {
  qualificacao: QualificacaoAnuncio | 'todas'
  anuncio?: string
  de?: string
  ate?: string
  pagina: number
  tamanho: number
}

export function useAnuncios(filtro: FiltroAnunciosTela) {
  return useQuery({
    queryKey: chavesAnuncios.lista(filtro),
    queryFn: () =>
      api<RespostaAnuncios>('/api/anuncios', {
        query: {
          qualificacao: filtro.qualificacao,
          anuncio: filtro.anuncio,
          de: filtro.de,
          ate: filtro.ate,
          pagina: filtro.pagina,
          tamanho: filtro.tamanho,
        },
      }),
  })
}

export function useQualificarLead() {
  const cliente = useQueryClient()
  return useMutation({
    mutationFn: ({
      id,
      qualificacao,
    }: {
      id: string
      qualificacao: QualificacaoAnuncio
      /** A conversa do lead, para a faixa no alto dela se atualizar. */
      chamadoId: string
    }) =>
      api<LeadAnuncioResumoDto>(`/api/anuncios/${id}`, {
        metodo: 'PATCH',
        corpo: { qualificacao },
      }),
    onSuccess: (_, variaveis) => {
      void cliente.invalidateQueries({ queryKey: chavesAnuncios.raiz })
      void cliente.invalidateQueries({ queryKey: chavesChat.chamado(variaveis.chamadoId) })
    },
  })
}
